import {
  AirHandlerTypeCodeType,
  AirHandlerTypeLabelType
} from '@alpinehomeair/common';
import {
  airHandlerTypeAbbreviations,
  airHandlerTypeCodes
} from 'data/constants';
import { DRAG_TYPE_TO_AIR_HANDLER_CODE } from 'utils/structure';

const airHandlerCodeToLabel = Object.fromEntries(
  Object.entries(airHandlerTypeCodes).map(([label, code]) => [code, label])
) as Record<AirHandlerTypeCodeType, AirHandlerTypeLabelType>;

const airHandlerDisplayLabelOverrides: Partial<
  Record<AirHandlerTypeCodeType, string>
> = {
  ducted: 'Ducted Air Handler'
};

export function getAirHandlerTypeLabel(
  code: AirHandlerTypeCodeType
): AirHandlerTypeLabelType | undefined {
  return airHandlerCodeToLabel[code];
}

export function getAirHandlerTypeDisplayLabel(
  code: AirHandlerTypeCodeType
): string {
  return (
    airHandlerDisplayLabelOverrides[code] ?? airHandlerCodeToLabel[code] ?? code
  );
}

export function getAirHandlerTypeFilterLabel(
  code: AirHandlerTypeCodeType
): string {
  const displayLabel = getAirHandlerTypeDisplayLabel(code);
  const catalogLabel = getAirHandlerTypeLabel(code);
  return catalogLabel && catalogLabel !== displayLabel
    ? `${displayLabel} (${catalogLabel})`
    : displayLabel;
}

export function getAbbreviationsForTypeCode(
  typeCode: AirHandlerTypeCodeType
): string[] {
  const label = airHandlerCodeToLabel[typeCode];
  return label ? airHandlerTypeAbbreviations[label] : [];
}

const DRAG_TYPE_CODE_GROUPS: Record<string, AirHandlerTypeCodeType[]> = {
  'new-air-handler-ceiling-cassette': ['cassette', 'cassette_drop_ceiling'],
  'new-air-handler-ceiling-cassette-slim-fit': ['cassette_16'],
  'new-air-handler-concealed-duct': ['concealed', 'concealed_high_static']
};

export function getAirHandlerTypeCodesForDragType(
  dragType: string
): AirHandlerTypeCodeType[] {
  if (DRAG_TYPE_CODE_GROUPS[dragType]) return DRAG_TYPE_CODE_GROUPS[dragType];
  const single = DRAG_TYPE_TO_AIR_HANDLER_CODE[dragType];
  return single ? [single] : [];
}
